import { Injectable } from '@angular/core';
import { ConfigStateService } from '@medlogic/shared/state-config';

export interface IProcessMenuCacheGroup {
  identifier: number;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProcessMenuCacheService {
  private readonly cacheKeyPrefix = 'medlogic.process-menu-groups.v1';

  constructor(private cnfState: ConfigStateService) { }

  get(): IProcessMenuCacheGroup[] | null {
    try {
      const cachedValue = localStorage.getItem(this.getCacheKey());

      if (!cachedValue) {
        return null;
      }

      const groups = JSON.parse(cachedValue);

      if (this.isValid(groups)) {
        return groups;
      }

      this.clear();
    } catch {
      this.clear();
    }

    return null;
  }

  set(groups: IProcessMenuCacheGroup[]): void {
    try {
      if (this.isValid(groups)) {
        localStorage.setItem(this.getCacheKey(), JSON.stringify(groups));
      }
    } catch { }
  }

  clear(): void {
    try {
      localStorage.removeItem(this.getCacheKey());
    } catch { }
  }

  private getCacheKey(): string {
    const customerId = Number.isFinite(this.cnfState.customerId) ? this.cnfState.customerId : 'anonymous';
    const usuarioLogadoNo = Number.isFinite(this.cnfState.usuarioLogadoNo) ? this.cnfState.usuarioLogadoNo : 'anonymous';

    return `${this.cacheKeyPrefix}.${customerId}.${usuarioLogadoNo}`;
  }

  private isValid(groups: unknown): groups is IProcessMenuCacheGroup[] {
    return Array.isArray(groups) && groups.every(group =>
      Number.isFinite(group?.identifier) && typeof group?.name === 'string' && !!group.name.trim()
    );
  }
}
